class Product {
  constructor() {
    this.productReview = document.querySelector(".product__review");
    this.addToCartBtn = document.querySelector(".product-form__submit");
    this.stickyATC = document.querySelector(".pdp-sticky");
    this.toggleElement = document.querySelector("[data-select-toggle]");
    this.optionsElement = document.querySelector("[data-select-options]");

    this.init();

    this.initializeCompleteTheLookDesktopSplide();
    this.initializeCompleteTheLookMobileSplide();
  }

  init() {
    this.productReview?.addEventListener("click", this.scrollProductReview.bind(this));
    this.toggleElement?.addEventListener("click", (event) => {
      event.stopPropagation();
      this.toggleDropdown();
    });
    document.addEventListener("click", (event) => {
      if (!this.toggleElement?.contains(event.target) && !this.optionsElement?.contains(event.target)) {
        this.optionsElement.style.display = "none";
      }
    });

    // Observe the add-to-cart button for sticky ATC
    this.observeAddToCart();
    this.initializeSelectSizePrompt();
  }

  // Scroll to product review section
  scrollProductReview() {
    let productReview = document.getElementById("product__review");
    if (!productReview) return;
    setTimeout(() => {
      productReview.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 50);
  }

  // Toggle dropdown visibility
  toggleDropdown() {
    if (this.optionsElement.style.display === "none" || this.optionsElement.style.display === "") {
      this.optionsElement.style.display = "block";
    } else {
      this.optionsElement.style.display = "none";
    }
  }

  // Toggle sticky Add to Cart button visibility
  toggleStickyATC(isVisible) {
    if (!this.stickyATC) return;
    this.stickyATC.style.transform = isVisible ? "translateY(100%)" : "translateY(0)";
  }

  // Observe Add to Cart button visibility and toggle sticky ATC
  observeAddToCart() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Show sticky ATC whenever the main button is not visible in the viewport
          if (entry.isIntersecting) {
            this.toggleStickyATC(true);
            if (this.optionsElement) this.optionsElement.style.display = "none";
            return;
          }

          this.toggleStickyATC(false);
        });
      },
      { threshold: 0 }
    );

    if (this.addToCartBtn) {
      observer.observe(this.addToCartBtn);
    }
  }

  initializeSelectSizePrompt() {
    if (!this.hasMultipleVariants()) return;

    const soldOutText = window.variantStrings?.soldOut || "SOLD OUT";
    const selectASizeText = window.variantStrings?.selectASize || "SELECT A SIZE";

    document.querySelectorAll(".product-form__submit").forEach((button) => {
      const label = button.querySelector("span");
      if (!label) return;
      if (label.textContent.trim() === soldOutText) return;

      button.disabled = true;
      label.textContent = selectASizeText;
    });
  }

  hasMultipleVariants() {
    return Boolean(document.querySelector('product-form[data-has-multiple-variants="true"]'));
  }

  // initialize the complete the look
  initializeCompleteTheLookDesktopSplide() {
    new Splide("#splide-complete-the-look-desktop", {
      type: "slide",
      gap: 18,
      perPage: 4,
      arrows: false,
      perMove: 1,
      lazyLoad: "sequential",
      breakpoints: {
        1280: { perPage: 3 },
        768: { perPage: 2 },
      },
    }).mount();
  }

  // initialize the complete the look mobile
  initializeCompleteTheLookMobileSplide() {
    new Splide("#splide-complete-the-look-mobile", {
      type: "slide",
      gap: 18,
      perPage: 4,
      arrows: false,
      perMove: 1,
      lazyLoad: "sequential",
      breakpoints: {
        1280: { perPage: 3 },
        768: { perPage: 2 },
      },
    }).mount();
  }
}

// Initialize Product class on DOMContentLoaded
document.addEventListener("DOMContentLoaded", function () {
  new Product();
});
